<template>
  <div class="form-control">
    <div class="filter-checkboxes gap-[30px] mt-6 flex flex-wrap rounded-xl drop-shadow-xl text-left">
      <label
          v-for="control in formControls"
          :key="control.id"
          class="label cursor-pointer button"
      >
        <span class="label-text text-black mr-2 inline-block">{{ control.label }}</span>

        <input
            type="checkbox"
            v-model="control.selected"
            @change="filterPlaygrounds()"
            class="checkbox checkbox-primary"
        >
      </label>
      
      <div class="form-control">
        <label class="label cursor-pointer button">
          <span class="label-text text-black mr-2 inline-block">Distance from center:</span>
          <select 
            v-model="selectedDistance" 
            @change="onDistanceChange()"
            class="select select-primary select-sm"
          >
            <option :value="null">All distances</option>
            <option :value="5">Within 5 miles</option>
            <option :value="25">Within 25 miles</option>
            <option :value="50">Within 50 miles</option>
            <option :value="100">Within 100 miles</option>
          </select>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default  {
  props: {
    currentCoordinates: Array
  },
  data () {
    return {
      formControls: [
        { label: 'Has Slides', id: 'slides', selected: false },
        { label: 'Has Bathrooms', id: 'bathrooms', selected: false },
        { label: 'Toddler Friendly', id: 'toddlerFriendly', selected: false },
        { label: 'Has Fireman Pole', id: 'firemanPole', selected: false },
      ],
      selectedDistance: null
    }
  },
  methods: {
    filterPlaygrounds() {
      // Create a list of the details to check for by keeping only those that are selected
      // then returning only the "id" which is the index in the details property.
      const selectedList = this.formControls
          .filter(control => control.selected)
          .map(selected => selected.id);
      this.$emit('filter', { features: selectedList, distance: this.selectedDistance });
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 3959; // Radius of Earth in miles
      const dLat = this.toRad(lat2 - lat1);
      const dLon = this.toRad(lon2 - lon1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },
    toRad(deg) {
      return deg * (Math.PI / 180);
    },
    onDistanceChange() {
      this.$emit('distance-changed', this.selectedDistance);
      this.filterPlaygrounds();
    }
  }
}
</script>